import { Component, OnInit, inject, effect } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { GenericState } from 'src/app/store/generic.state';
import { filter, take } from 'rxjs';
import { SignupQuestionsSignal } from 'src/app/signal/signup-questions.signal';
import * as _ from 'underscore';
import { GenericService } from 'src/app/services/generic.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NgClass } from '@angular/common';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzSelectModule } from 'ng-zorro-antd/select';

@Component({
	selector: 'app-interested-roles',
	templateUrl: './interested-roles.html',
	styleUrl: './interested-roles.scss',
	imports: [FormsModule, ReactiveFormsModule, NzGridModule, NgClass, NzSpaceModule, NzSelectModule]
})
export class InterestedRoles implements OnInit {
	private readonly genericActions$ = inject(Store).select(GenericState.getGeneric);
	private readonly signupQuestionsSignal = inject(SignupQuestionsSignal);
	private readonly genericService = inject(GenericService);
	private readonly ngxLoader = inject(NgxUiLoaderService);
	
	public form: FormGroup;
	public jobCategories: any[] = [];
	public roles: any[] = [];
	public proficiencyLevels: any[] = [];
	private currentSelectedRoles: any[] = [];

	constructor() {
		// Effect to watch job profiles from signal
		effect(() => {
			const rolesExp = this.signupQuestionsSignal.rolesExperience();
			this.currentSelectedRoles = rolesExp?.jobProfiles || [];
		});
	}

	ngOnInit(): void {
		this.buildForm();

		this.genericActions$
			.pipe(
				filter((data: any) => !_.isEmpty(data.jobRoleCategories)),
				take(1)
			)
			.subscribe((filteredData: any) => {
				this.jobCategories = filteredData.jobRoleCategories;
			});

		this.form.get('jobCategoryId')?.valueChanges.subscribe((value) => {
			this.form.patchValue({ roleId: null, levelId: null });
			this.roles = [];
			this.proficiencyLevels = [];
			if (value !== null) {
				this.ngxLoader.start();
				this.genericService
					.get(`ApplicantProtected/GetJobProfileRoleByCategory/${value}`)
					.subscribe({
						next: (data: any) => {
							const filteredRoleCategory = this.currentSelectedRoles
								?.filter((a: any) => a.categoryId === value)
								?.map((b: any) => b.roleName);
							this.roles = data?.filter(
								(role: any) => !filteredRoleCategory?.includes(role.jobRoleName)
							);
						},
						error: () => {
							this.ngxLoader.stop();
						},
						complete: () => {
							this.ngxLoader.stop();
						}
					});
			}
		});

		this.form.get('roleId')?.valueChanges.subscribe((value) => {
			this.form.patchValue({ levelId: null });
			this.proficiencyLevels =
				this.roles.find((e: any) => e.roleId === value)?.levels || [];
		});

		this.form.get('levelId')?.valueChanges.subscribe((value) => {
			if (!_.isNull(value)) {
				setTimeout(() => {
					const setData = {
						categoryId: this.form.value.jobCategoryId,
						categoryName: this.jobCategories.find(
							(e: any) => e.id === this.form.value.jobCategoryId
						)?.value,
						roleId: this.form.value.roleId,
						roleName: this.roles.find(
							(e: any) => e.roleId === this.form.value.roleId
						)?.jobRoleName,
						levelId: this.form.value.levelId,
						levelName: this.proficiencyLevels.find(
							(e: any) => e.levelId === this.form.value.levelId
						)?.levelName,
						isFormValid: this.form.valid
					};

					this.signupQuestionsSignal.addJobProfile(setData);
				}, 500);
			}
		});
	}

	private buildForm(): void {
		this.form = new FormGroup({
			jobCategoryId: new FormControl(null, Validators.required),
			roleId: new FormControl(null, Validators.required),
			levelId: new FormControl(null, Validators.required)
		});
	}
}
